import angular from 'angular';

import { DATE_FMT_MMDDYYYY } from '../constants';

export default angular.module('myDirectives', [])
  .directive('jmLoader', function () {
    return {
      restrict: 'E',
      template: '<div class="full-screen-overlay"><div class="full-screen-overlay-centerbox"><img src="'
        + require("../assets/images/bluespinner.gif")
        + '"></div></div>'
    };
  })
  .directive('datemmddyyyy', function () {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        ctrl.$validators.datemmddyyyy = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            // consider empty models to be true
            return true;
          }

          if (DATE_FMT_MMDDYYYY.test(viewValue)) {
            // it passes regex
            return true;
          }

          // it is invalid
          return false;
        };
      }
    };
  })
  .directive('focus',
    function ($timeout) {
      return {
        scope: {
          trigger: '@focus'
        },
        link: function (scope, element) {
          scope.$watch('trigger', function (value) {
            if (value === "true") {
              $timeout(function () {
                element[0].focus();
              });
            }
          });
        }
      };
    })
  .directive('blur', [() => {
    return {
      restrict: 'A',
      link: (scope, element) => {
        element.on('focus', () => element[0].blur());
      }
    };
  }])
  .directive('cgpassword', function () {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        ctrl.$validators.integer = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            // consider empty models to be valid
            return true;
          }

          if (viewValue.length >= 6 && viewValue.replace(/[^0-9]/g, "").length && viewValue.replace(/[^a-z]/g, "")) {
            // it is valid
            return true;
          }

          // it is invalid
          return false;
        };
      }
    };
  });